(function() {

angular.module('ngmvac').
directive('hotelMap', function() {
    // directive link function
    var link = function(scope, element, attrs) {
        var map;
        var markers = [];
        var maps = [];
    
    
        // map config
        var mapOptions = {
            center: new google.maps.LatLng(parseFloat(attrs.latitude), parseFloat(attrs.longitude)),
            zoom: 17,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            disableDefaultUI: true,
            fullscreenControl: true,
            zoomControl:true
        };
        
        // init the map
        function initMap() {
            if (map === void 0) {
                map = new google.maps.Map(element[0], mapOptions);
                new google.maps.event.trigger(map, 'resize');
                map.setCenter(map.getCenter());
            }
        }
        
        // place a marker
        function setMarker(map, position, title, content) {
            var marker;
            var markerOptions = {
                position: position,
                map: map,
                title: title,
                icon: attrs.urlmarker
            };
   

            if(attrs.hotelname != undefined)
            {
                
                var contentattrs ="";
                    contentattrs += "<span style='font-size:12px !important;'><b>"+attrs.address;
                    if(attrs.postalcode != undefined)
                    {
                      contentattrs +=attrs.postalcode+"  "+attrs.city+"</b></span>";
                    }
                    
        
                var infowindow = new google.maps.InfoWindow({
                    content: contentattrs
                    });
            }
            marker = new google.maps.Marker(markerOptions);
            markers.push(marker); // add marker to array


     
     
   
          infowindow.open(map, marker);

             marker.addListener('click', function() {
               infowindow.open(map, marker);

             });
       
            
        
        }
        
        // show the map and place some markers
        initMap();
        setMarker(map, new google.maps.LatLng(parseFloat(attrs.latitude), parseFloat(attrs.longitude)));
        window.setTimeout(function () {
            currentCenter = map.getCenter();
            google.maps.event.trigger(map, 'resize');
            map.setCenter(currentCenter);
        }, 1000);
    };
    
    return {
        restrict: 'A',
        template: '<div class="mapa"></div>',
        replace: true, 
        link: link
    };
});

})();